import { createFileRoute } from '@tanstack/react-router';
import { JourneysReportingWebhooksHandoff } from '@/pages/workspaces/integrations/reporting-webhooks/routing';

function JourneysReportingWebhooksIndexRoute() {
  return <JourneysReportingWebhooksHandoff kind="index" />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/',
)({
  component: JourneysReportingWebhooksIndexRoute,
});
